import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import "./about.css";

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="about_wrapper">
      <div className="container">
        {/* Tiêu đề lớn */}
        <h1 className="about-title">{t('about_title')}</h1>

        <div className="about-layout">
          {/* Sidebar Icon bên trái */}
          <aside className="about-sidebar">
            <div className="side-item active">
              <i className="icon-restaurant"></i>
              <span>{t('about_sidebar_restaurant')}</span>
            </div>
            <div className="side-item">
              <i className="icon-farm"></i>
              <span>{t('about_sidebar_farm')}</span>
            </div>
            <div className="side-item">
              <i className="icon-food"></i>
              <span>{t('about_sidebar_cuisine')}</span>
            </div>
            <div className="side-item">
              <i className="icon-art"></i>
              <span>{t('about_sidebar_art')}</span>
            </div>
          </aside>

          {/* Nội dung văn bản ở giữa */}
          <article className="about-text">
            <p>{t('about_p1')}</p>
            <p>{t('about_p2')}</p>
            <p>{t('about_p3')}</p>
            <p>{t('about_p4')}</p>
            <p>{t('about_p5')}</p>
          </article>

          {/* Cụm hình ảnh bên phải */}
          <section className="about-images">
            <div className="img-column">
              <div className="img-item tall" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=600&q=80')" }}></div>
              <div className="img-item" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1600565193348-f74bd3c7ccdf?auto=format&fit=crop&w=600&q=80')" }}></div>
            </div>
            <div className="img-column">
              <div className="img-item" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=600&q=80')" }}></div>
              <div className="img-item tall" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1592394933325-10eb7c944968?auto=format&fit=crop&w=600&q=80')" }}></div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;